import { InternalDatasets } from "Services/helpers";
import { ROUTES } from "Services/Route/Route.types";
import {fetchOffer, fetchOfferValues} from 'Store/Offer/Actions';

class EntityHelper {
    static getEntityRoute = (entity, id) => {
        switch (entity) {
            case InternalDatasets.CANDIDATES:
            case 'candidate':
                return ROUTES.CANDIDATES.DETAILED.getFullPath(id);
            case InternalDatasets.VACANCIES:
            case 'vacancy':
                return ROUTES.VACANCIES.DETAILED.getFullPath(id);
            case InternalDatasets.BUSINESS_UNITS:
            case 'business_unit':    
                return ROUTES.BUSINESS_UNITS.DETAILED.getFullPath(id);
            case InternalDatasets.CONTACT:
            case 'contact':
                return ROUTES.CONTACTS.DETAILED.getFullPath(id);
            case 'offer':
            case InternalDatasets.OFFERS:
                return ROUTES.OFFERS.DETAILED.getFullPath(id);
            default:
                return '/';
        }
    }

    /*
    * @deprecated
    */
    static entityEndpoint(entity) {
        switch (entity) {
            case 'candidate':
                return 'candidates';
            case 'vacancy':
                return 'vacancies';
            case 'business_unit':
                return 'business_units';
            case 'contact':
                return 'contacts';
            case 'offer':
                return 'offers';
            default:
                return '';
        }
    }

    static getEndpoint(entity) {
        switch (entity) {
            case 'candidate':
                return 'candidates';
            case 'business_unit':
            case 'company':
                return 'companies';
            case 'contact':
                return 'contacts';
            case 'vacancy':
                return 'vacancies';
            case 'offer':
                return 'offers';
            default:
                return '';
        }
    }
    static getEntityOverviewEndpointByEntityName(entity)
    {
        switch (entity) {
            case 'candidate':
                return ROUTES.CANDIDATES.path;
            case 'vacancy':
                return ROUTES.VACANCIES.path;
            case 'business_unit':
                return ROUTES.BUSINESS_UNITS.path;
            case 'contact':
                return ROUTES.CONTACTS.path;
            case 'offer':
                return ROUTES.OFFERS.path;
            default:
                return '';
        }
    }

    static pluralToSingularEntity(entity) {
        switch (entity) {
            case 'candidates':
                return 'candidate';
            case 'vacancies':
                return 'vacancy';
            case 'business_units':
                return 'business_unit';
            case 'contacts':
                return 'contact';
            case 'offers':
                return 'offer';
            default:
                return '';
        }
    }

    static formattedEntityToSystemEntity(entity) {
        switch (entity) {
            case 'kandidaten':
                return 'candidates';
            case 'vacatures':
                return 'vacancies';
            case 'bedrijven':
                return 'business_units';
            case 'contactpersonen':
                return 'contacts';
            case 'aanbiedingen':
                return 'offers';
            default:
                return '';
        }
    }

    static getEntityNameFromDatasetId = (datasetId: number) => {
        switch (datasetId) {
            case -1:
                return 'candidate';
            case -2:
                return 'vacancy';
            case -4:
                return 'business_unit';
            case -5:
                return 'contact';
            case -6:
                return 'users';
            default:
                return '';
        }
    }

    static getDisplayValueByName(input) {
        switch (input) {
            case 'candidate':
                return 'Kandidaten';
            case 'vacancy':
                return 'Vacatures';
            case 'business':
                return 'Bedrijven (OLD)';
            case 'business_unit':
            case 'company':
                return 'Bedrijven';
            case 'contact':
                return 'Contactpersonen';
            case 'offer':
                return 'Aanbiedingen';
            default:
                return '';
        }
    }

    static getSingularDisplayValueByName(input) {
        switch (input) {
            case 'candidate':
                return 'Kandidaat';
            case 'vacancy':
                return 'Vacature';
            case 'business':
                return 'Bedrijf (OLD)';
            case 'business_unit':
                return 'Bedrijf';
            case 'contact':
                return 'Contactpersoon';
            case 'offer':
                return 'Aanbieding';
            default:
                return '';
        }
    }

    static create = (props: any, entityName: string) => {
        if (!entityName) return () => {};

        switch (entityName) {
            case 'vacancy':
                return props?.createVacancy;
            case 'candidate':
                return props?.createCandidate;
            case 'business_unit':
                return props?.createBusinessUnit;
            case 'contact':
                return props?.createContact;
            case 'offer':
                return props?.createOffer;
            default:
                throw new Error("COULD NOT FIND ENTITY");
        }
    }
    
    static update = (props: any, entityName: string) => {
        if (!entityName) return () => {};

        switch (entityName) {
            case 'vacancy':
                return props?.updateVacancy;
            case 'candidate':
                return props?.updateCandidate;
            case 'business_unit':
                return props?.updateBusinessUnit;
            case 'contact':
                return props?.updateContact;
            case 'offer':
                return props?.updateOffer;
            default:
                throw new Error("COULD NOT FIND ENTITY");
        }
    }

    static delete = (props: any, entityName: string) => {
        if (!entityName) return () => {};

        switch (entityName) {
            case 'vacancy':
                return props?.deleteVacancy;
            case 'candidate':
                return props?.deleteCandidate;
            case 'business_unit':
                return props?.deleteBusinessUnit;
            case 'contact':
                return props?.deleteContact;
            case 'offer':
                return props?.deleteOffer;
            default:
                throw new Error("COULD NOT FIND ENTITY");
        }
    }

    static createValue = (props: any, entityName: string) => {
        switch (entityName) {
            case 'vacancy':
                return props?.createVacancyValues;
            case 'candidate':
                return props?.createCandidateValues;
            case 'business_unit':
                return props?.createBusinessUnitValues;
            case 'contact':
                return props?.createContactValues;
            case 'offer':
                return props?.createOfferValues;
            default:
                throw new Error("COULD NOT FIND ENTITY");
        }
    }

    static updateValue = (props: any, entityName: string) => {
        if (!entityName) return () => {};
        
        switch (entityName) {
            case 'vacancy':
                return props?.updateVacancyValues;
            case 'candidate':
                return props?.updateCandidateValues;
            case 'business_unit':
                return props?.updateBusinessUnitValues;
            case 'contact':
                return props?.updateContactValues;
            case 'offer':
                return props?.updateOfferValues;
            default:
                return () => {};
        }
    }

    static upsertValues = (props: any, entityName: string) => {
        switch (entityName) {
            case 'contact':
                return props.upsertContactValues;
            case 'business_unit':
                return props.upsertBusinessUnitValues;
            case 'candidate':
                return props.upsertCandidateValues;
            case 'vacancy':
                return props.upsertVacancyValues;
            case 'offer':
                return props.upsertOfferValues;
            default:
                throw new Error("COULD NOT FIND ENTITY");
        }
    }

    static fetchOverviewByPagenumber = (props: any, entityName: string) => {
        if (!entityName) return () => {};
        
        switch (entityName) {
            case 'vacancy':
                return props?.fetchVacancyOverviewByPagenumber;
            case 'candidate':
                return props?.fetchCandidateOverviewByPagenumber;
            case 'business_unit':
                return props?.fetchBusinessUnitOverviewByPagenumber;
            case 'contact':
                return props?.fetchContactOverviewByPagenumber;
            case 'offer':
                return props?.fetchOfferOverviewByPagenumber;
            default:
                return () => {};
        }
    }

    static fetchRecordById = (props: any, entityName: string) => (record_id: string) => {
        if (!entityName) return () => {};
        
        switch (entityName) {
            case 'contact':
                props.fetchContactV2(record_id);
                props.fetchContactValues(record_id);
                break;
            case 'business_unit':
                props.fetchBusinessUnitV2(record_id);
                props.fetchBusinessUnitValues(record_id);
                break;
            case 'candidate':
                props.fetchCandidateV2(record_id);
                props.fetchCandidateValues(record_id);
                break;
            case 'vacancy':
                props.fetchVacancyV2(record_id);
                props.fetchVacancyValues(record_id);
                break;
            case 'offer':
                props.fetchOffer(record_id);
                props.fetchOfferValues(record_id);
                break;
            default:
                return;
        }
    }

    static fetchConceptRecord = (props: any, entityName: string) => () => {
        if (!entityName) return () => {};
        
        switch (entityName) {
            case 'contact':
                return props.fetchContactConcept();
            case 'business_unit':
                return props.fetchBusinessUnitConcept();
            case 'candidate':
                return props.fetchCandidateConcept();
            case 'vacancy':
                return props.fetchVacancyConcept();
            default:
                return;
        }
    }

    static fetchDatasetByDatasetId = (props: any, entityDatasetId: any) => () => {
        if (!entityDatasetId) return () => {};
        
        switch (entityDatasetId) {
            case 'contact':
            case InternalDatasets.CONTACT:
                return props.fetchContactDataset();
            case 'business_unit':
            case InternalDatasets.BUSINESS_UNITS:
                return props.fetchBusinessUnitDataset();
            case 'candidate':
            case InternalDatasets.CANDIDATES:
                return props.fetchCandidateDataset();
            case 'vacancy':
            case InternalDatasets.VACANCIES:
                return props.fetchVacancyDataset();
            default:
                return;
        }
    }
}

export default EntityHelper;